export const SET_LANDING_PAGE = "SET_LANDING_PAGE";
export const SET_BUSINESS_CATEGORY = "SET_BUSINESS_CATEGORY"